import { Breadcrumb, Col, Layout, message, Progress, Row } from "antd";
import React from "react";
import { connect } from "react-redux";
import { AuthActions } from "app/redux/actions";
import { LoadingSelectors, AuthSelectors } from "app/redux/reducers";
import { I18n } from "react-redux-i18n";
import AdvancedButton from "components/shared/AdvancedButton/AdvancedButton";
import AdvancedHeader from "components/shared/AdvancedHeader/AdvancedHeader";
import AdvancedInput from "components/shared/AdvancedInput/AdvancedInput";
import BackButton from "components/shared/BackButton/BackButton";
import { useNavigate, useLocation } from "react-router-dom";

const { Content } = Layout;

class PasswordRecoveryCode extends React.PureComponent {
  state = {
    changeToken: "",
    email: "",
    password: "",
    passwordConfirmation: "",
  };

  componentDidMount() {
    const { location } = this.props;
    if (location?.state?.email) {
      this.setState({ email: location.state.email });
    }
  }

  onInputChange(name, value) {
    this.setState({
      [name]: value,
    });
  }

  onSubmit(e) {
    e.preventDefault();

    const { changeToken, password, passwordConfirmation, email } = this.state;
    const { changePassword } = this.props;

    console.log("data", this.props.data);
    console.log("email", email);
    console.log("changeToken", changeToken);
    console.log("password", password);
    console.log("passwordConfirmation", passwordConfirmation);

    if (!changeToken || !password || !passwordConfirmation) {
      return message.error(I18n.t("routes.passwordRecoveryCode.errors.filled"));
    }

    if (password.length < 6) {
      return message.error(
        I18n.t("routes.passwordRecoveryCode.errors.tooshort")
      );
    }

    if (password !== passwordConfirmation) {
      return message.error(
        I18n.t("routes.passwordRecoveryCode.errors.unmatch")
      );
    }

    changePassword({ changeToken, password, email }, () => {
      this.props.navigate(I18n.t("routes.login.url"));
      message.success(I18n.t("routes.passwordRecoveryCode.messages.success"));
    });
  }

  render() {
    const { loading } = this.props;
    const { changeToken, password, passwordConfirmation } = this.state;

    return (
      <>
        <Layout className="advanced-layout">
          <AdvancedHeader />
          <Content className="advanced-layout__content">
            <Breadcrumb className="advanced-layout__content__bread ">
              <Breadcrumb.Item>
                {I18n.t("routes.passwordRecoveryCode.parent")}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {I18n.t("routes.passwordRecoveryCode.pageTitle")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <form onSubmit={e => this.onSubmit(e)}>
              <h1 className="advanced-layout__content__title mt-4">
                {I18n.t("routes.passwordRecoveryCode.content.title")}
              </h1>
              <p className="advanced-layout__content__subtitle">
                {I18n.t("routes.passwordRecoveryCode.content.subtitle")}
              </p>
              <p className="advanced-layout__content__step">
                {I18n.t("routes.passwordRecoveryCode.content.step")}
              </p>
              <Progress percent={100} status="active" showInfo={false} />
              <Row gutter={[10, 10]} className="mt-3">
                <Col span={16}>
                  <AdvancedInput
                    placeholder={I18n.t(
                      "routes.passwordRecoveryCode.form.tokenPlaceholder"
                    )}
                    label="Token recebido no email informado"
                    value={changeToken}
                    onChange={value => this.onInputChange("changeToken", value)}
                  />
                </Col>
              </Row>
              <Row gutter={[10, 10]}>
                <Col span={8}>
                  <AdvancedInput
                    placeholder={I18n.t(
                      "routes.passwordRecoveryCode.form.passwordPlaceholder"
                    )}
                    label={I18n.t(
                      "routes.passwordRecoveryCode.form.passwordLabel"
                    )}
                    value={password}
                    isPassword
                    onChange={value => this.onInputChange("password", value)}
                  />
                </Col>
                <Col span={8}>
                  <AdvancedInput
                    placeholder={I18n.t(
                      "routes.passwordRecoveryCode.form.passConfirmationPlaceholder"
                    )}
                    label={I18n.t(
                      "routes.passwordRecoveryCode.form.passConfirmationLabel"
                    )}
                    value={passwordConfirmation}
                    isPassword
                    onChange={value =>
                      this.onInputChange("passwordConfirmation", value)
                    }
                  />
                </Col>
              </Row>
              <Row
                align="middle"
                justify="end"
                gutter={[10, 10]}
                className="mt-3"
              >
                <Col xs={24} sm={8} md={4} lg={4}>
                  <BackButton
                    text={I18n.t("components.backButton")}
                    onClick={() =>
                      this.props.navigate(I18n.t("routes.passwordRecovery.url"))
                    }
                  />
                </Col>
                <Col xs={24} sm={8} md={4} lg={4}>
                  <AdvancedButton
                    disabled={loading && loading}
                    text={I18n.t("components.nextButton")}
                    isNext
                    submit
                  />
                </Col>
              </Row>
            </form>
          </Content>
        </Layout>
      </>
    );
  }
}

const mapStateToProps = state => ({
  loading: LoadingSelectors.getLoading(state),
  data: AuthSelectors.getData(state),
});

const mapDispatchToProps = dispatch => ({
  changePassword: (data, callback) =>
    dispatch(AuthActions.changePassword(data, callback)),
});

const PasswordRecoveryCodeWithNavigate = props => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <PasswordRecoveryCode {...props} navigate={navigate} location={location} />
  );
};
PasswordRecoveryCodeWithNavigate.displayName =
  "PasswordRecoveryCodeWithNavigate";

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordRecoveryCodeWithNavigate);
